import React from 'react';
import CustomerReportContainer from './customer-reports/CustomerReportContainer';

const CustomerReport = () => {

    return(
        <React.Fragment>
            <CustomerReportContainer/>
        </React.Fragment>
    )
}

export default CustomerReport;